import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { BootstrapService } from "../modules/bootstrap/bootstrap.service";
import { enableHXRStorageMemberToken } from "src/xhr-interceptos";

@Injectable()
export class CookieAuthStorageGuard {
  constructor(private bootstrapService: BootstrapService) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    const currentMember = this.bootstrapService.getCurrentMemberAuth()!;

    enableHXRStorageMemberToken(currentMember.token);

    return true;
  }
}
